export default __webpack_public_path__ + "static/media/screen_livechat_09.3d9e2751.png";